import React from "react";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Container, PageHeader, Spinner, EmptyState } from "@/components/common";
import { LevelBadge } from "@/components/LevelBadge";
import { formatTime, formatPrice } from "@/lib/format";
import { MapPin, Clock, Navigation, ListMusic } from "lucide-react";

export default function WhatsOn() {
  const { data, isLoading } = useQuery({ queryKey: ["whats-on"], queryFn: async () => (await api.get("/whats-on")).data });
  if (isLoading) return <Spinner />;
  const list = data?.today_classes?.length ? data.today_classes : data?.upcoming_classes;
  const isToday = data?.today_classes?.length > 0;

  return (
    <div>
      <PageHeader eyebrow="What's on" title={isToday ? `It's ${data.today_name}!` : "Coming up next"}
        subtitle={isToday ? "Here's where we're dancing today." : "No class today — here's what's next."} />
      <Container className="py-8">
        {!list?.length ? <EmptyState title="No classes found" /> : (
          <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
            {list.map((c) => (
              <div key={c.id} className="rounded-2xl border border-border bg-card p-6" data-testid={`whatson-${c.slug}`}>
                <div className="flex items-start justify-between gap-2">
                  <h2 className="font-display text-xl font-bold text-[#2D1E18]">{c.name}</h2>
                  {c.is_mine && <span className="rounded-full bg-[#E8F0EC] px-2 py-0.5 text-[10px] font-bold uppercase text-[#4A6B5D]">Yours</span>}
                </div>
                <div className="mt-3 space-y-2 text-[#5C4A42]">
                  <p className="inline-flex items-center gap-2"><Clock size={16} className="text-[#B04B26]" /> {c.day} · {formatTime(c.start_time)}–{formatTime(c.finish_time)}</p>
                  <p className="inline-flex items-center gap-2"><MapPin size={16} className="text-[#B04B26]" /> {c.venue?.name}</p>
                  <p className="font-bold text-[#B04B26]">{formatPrice(c.price)}</p>
                </div>
                <div className="mt-5 flex flex-wrap gap-2">
                  <Link to={`/classes/${c.slug}`} className="inline-flex items-center gap-1.5 rounded-full bg-[#C85A32] px-4 py-2.5 text-sm font-bold text-white hover:bg-[#B04B26]"><ListMusic size={15} /> Class &amp; playlist</Link>
                  {c.venue?.postcode && <a href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(c.venue.name + " " + c.venue.postcode)}`} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 rounded-full border border-border px-4 py-2.5 text-sm font-semibold text-[#5C4A42] hover:border-[#C85A32]"><Navigation size={15} /> Directions</a>}
                </div>
              </div>
            ))}
          </div>
        )}
      </Container>
    </div>
  );
}
